import { render, staticRenderFns } from "./EditTruck.vue?vue&type=template&id=16e0a232&scoped=true"
import script from "./EditTruck.vue?vue&type=script&lang=js"
export * from "./EditTruck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e0a232",
  null
  
)

export default component.exports